
export const CHAR_UNMATCH = "unmatch";
export const CHAR_INCOMPLETE = "incomplete";
export const CHAR_COMPLETE = "complete";

// 「っ」の連続系用 「ssu」みたいなやつ
export const CHAR_PARTIALLY_COMPLETE = "partially_complete";
